// "use server";
import axios, { AxiosRequestConfig } from "axios";

export const axiosInstance = axios.create({
  baseURL: "/api",
  headers: {
    Accept: "application/json",
    // authorization: `Bearer ${authToken}`,
    "Content-Type": "application/json",
  },
});

interface ApiResponse<T> {
  status: number | boolean;
  statusCode?: number | string;
  data?: any;
  message?: string;
  messageCode?: string;
}

interface ResponseData {
  statusCode: number | string;
}

export const axiosGetRequest = async <T extends ResponseData>(
  url: string,
  config?: AxiosRequestConfig
): Promise<ApiResponse<T>> => {
  try {
    const response = await axiosInstance.get<T>(url, config);

    // Return structured success response
    return {
      status: response.status,
      data: response.data,
      statusCode: response.status,
      message: "Request successful",
    };
  } catch (error: any) {
    // console.log("Error in axiosGetRequest == 44", {
    //   url,
    //   response: error.response,
    //   status: false,
    //   message: error.response?.data?.message,
    //   statusCode: error.response?.status,
    // });

    // Return structured error response
    return {
      status: false,
      message: error.response?.data?.message || "Something went wrong",
      statusCode: error.response?.status || "TECHNICAL_ERROR",
    };
  }
};
